/** Public services.knls.in chrome + enquiry form — English, Telugu, Hindi. */

export const PUBLIC_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
];

export const PURPOSE_PRESETS = [
  {
    id: 'job',
    enLabel: 'Job notification enquiry',
  },
  {
    id: 'course',
    enLabel: 'Course / training enquiry',
  },
  {
    id: 'service',
    enLabel: 'Government / online service',
  },
  {
    id: 'certificate',
    enLabel: 'Certificate / hall ticket help',
  },
  {
    id: 'product',
    enLabel: 'Product or shop work',
  },
  {
    id: 'locsy',
    enLabel: 'Locsy Citizen app help',
  },
  {
    id: 'mitra',
    enLabel: 'Mitra / shop app help',
  },
  {
    id: 'app_tech',
    enLabel: 'App login or technical issue',
  },
  {
    id: 'other',
    enLabel: 'Other enquiry',
  },
];

export const CALL_TIME_PRESETS = [
  { id: 'anytime', enLabel: 'Anytime' },
  { id: 'morning', enLabel: 'Morning (9–12)' },
  { id: 'afternoon', enLabel: 'Afternoon (12–4)' },
  { id: 'evening', enLabel: 'Evening (4–8)' },
];

const STRINGS = {
  en: {
    // Chrome
    navHome: 'Home',
    navServices: 'Services',
    navCourses: 'Courses',
    navJobAlerts: 'Job Alerts',
    navEnquiry: 'Enquiry',
    navLegal: 'Legal',
    navMenu: 'Menu',
    navCloseMenu: 'Close navigation menu',
    navOpenMenu: 'Open navigation menu',
    privacyPolicy: 'Privacy Policy',
    locsyTerms: 'Locsy Terms',
    lmsTerms: 'LMS Terms',
    disclaimer: 'Disclaimer',
    refundPolicy: 'Refund Policy',
    cookiePolicy: 'Cookie Policy',
    deleteAccount: 'Delete Account',
    footerBlurb: 'Loksy Citizen and Loksy Mitra — local shops, listings, and Membership Plans for your town.',
    contact: 'Contact',
    enquiryForm: 'Enquiry form',
    locsyCitizen: 'Locsy Citizen',
    copyright: '© {year} Loksy. All rights reserved.',
    brandHome: 'Loksy home',
    changeLanguage: 'Language',

    // Enquiry form
    pageTitle: 'Enquiry — Loksy',
    kicker: 'KNLS · Locsy',
    title: 'Enquiry',
    lead: 'Tell us what you need — one quick step at a time. No login required.',
    callNow: 'Need help now? Call',
    whatsapp: 'WhatsApp',
    waPrefill: 'Hi, I have an enquiry.',

    purposeTitle: 'What do you need help with?',
    purposeSub: 'Pick one — you can add more details later.',
    purposeJob: 'Job notification enquiry',
    purposeJobHint: 'Govt / private job alerts on WhatsApp',
    purposeCourse: 'Course / training enquiry',
    purposeCourseHint: 'Computer courses, typing, certifications',
    purposeService: 'Government / online service',
    purposeServiceHint: 'Aadhaar, certificates, applications',
    purposeCertificate: 'Certificate / hall ticket help',
    purposeCertificateHint: 'Results, hall tickets, verification',
    purposeProduct: 'Product or shop work',
    purposeProductHint: 'Print, xerox, forms, other counter work',
    purposeLocsy: 'Locsy Citizen app help',
    purposeLocsyHint: 'Download, login, coupons, town listings',
    purposeMitra: 'Mitra / shop app help',
    purposeMitraHint: 'Billing, shop QR, Mitra login or setup',
    purposeAppTech: 'App login or technical issue',
    purposeAppTechHint: 'OTP, crash, update, or account problems',
    purposeOther: 'Other enquiry',
    purposeOtherHint: 'Tell us in your own words',
    describeBriefly: 'Describe briefly',
    describePlaceholder: 'e.g. Need help with ration card',

    nameTitle: 'What is your name?',
    nameSub: 'So our team can address you when they call.',
    fullName: 'Full name',
    namePlaceholder: 'Your name',

    phoneTitle: 'Your mobile number',
    phoneSub: 'Enter your number so our team can call you back. We will also try to send an OTP.',
    phoneLabel: '10-digit mobile',
    sendingOtp: 'Saving & sending OTP…',
    sendOtp: 'Save & send OTP',
    callbackConsent:
      'I agree that KNLS / Locsy staff may call or WhatsApp me on this number about my enquiry.',
    callbackConsentNote:
      'You already agreed to a callback. Your lead is visible to our operators even if OTP fails.',
    leadSavedCall: 'Your details were saved. Our team will call you soon.',
    skipOtpContinue: 'Didn’t get OTP? Continue — we will call you',
    otpNotDelivered:
      'OTP SMS was not delivered. Tap Resend OTP, or enter the code if it arrives.',
    otpSubRetry: 'OTP may not have arrived on +91 {phone}. Tap Resend OTP, then enter the 6-digit code.',
    verifyContinue: 'Verify & continue',

    otpTitle: 'Enter OTP',
    otpSub: 'Sent to +91 {phone}',
    otpLabel: '6-digit OTP',
    resendIn: 'Resend in {seconds}s',
    resendOtp: 'Resend OTP',
    otpSentTo: 'OTP sent to +91 {phone}',

    detailsTitle: 'A few optional details',
    detailsSub: 'Skip any field — tap Submit when ready.',
    villageLabel: 'Village / City (optional)',
    villagePlaceholder: 'e.g. Marribandam',
    addressLabel: 'Address (optional)',
    addressPlaceholder: 'Landmark or street',
    callTimeLegend: 'Best time to call you',
    callAnytime: 'Anytime',
    callMorning: 'Morning (9–12)',
    callAfternoon: 'Afternoon (12–4)',
    callEvening: 'Evening (4–8)',
    remarksLabel: 'Anything else? (optional)',
    remarksPlaceholder: 'Course name, job type, documents needed…',
    summaryName: 'Name',
    summaryPhone: 'Phone',
    summaryNeed: 'Need',
    submitting: 'Submitting…',
    submitEnquiry: 'Submit enquiry',

    doneTitle: 'Enquiry received',
    thanksNamed: 'Thanks {name}! Our team will call you about {need}.',
    thanksAnon: 'Thanks! Our team will call you about {need}.',
    callDirect: 'You can also call us directly:',
    callNumber: 'Call {num}',
    anotherEnquiry: 'Submit another enquiry',

    back: '← Back',
    continue: 'Continue',
    footnote:
      'Your enquiry is saved for our operators under Leads → Enquiries as soon as you share your phone (with consent). OTP helps confirm the number — no account is created.',

    errChoosePurpose: 'Please choose what you need help with',
    errDescribe: 'Please briefly describe your enquiry',
    errName: 'Please enter your full name',
    errPhone: 'Enter a valid 10-digit mobile number',
    errOtp: 'Enter the 6-digit OTP',
    errConsent: 'Please agree to a callback so our staff can support you',
    errSendOtp: 'Failed to send OTP',
    errSendOtpRetry: 'Failed to send OTP. Please try again.',
    errSubmit: 'Failed to submit enquiry',
    errNameRequired: 'Name is required',
    errOtpSentMobile: 'Enter the 6-digit OTP sent to your mobile',
    errChooseOrDescribe: 'Please choose or describe what you need help with',
    errOtpInvalid: 'Invalid or expired OTP',
    errOtpDigits: 'OTP must be 6 digits',
    errPhoneFormat: 'Invalid phone number format',
    errOtpAttempts: 'Too many failed OTP attempts. Please wait and try again.',
    errOtpInvalidLater: 'Too many invalid OTP attempts. Please request a new OTP later.',
    errOtpWait: 'Please wait {seconds}s before requesting OTP again',
    errOtpSms: 'OTP could not be delivered by SMS. Please try again.',
    errConsentApi: 'Please agree to a callback from our staff before continuing',
  },
  te: {
    navHome: 'హోమ్',
    navServices: 'సేవలు',
    navCourses: 'కోర్సులు',
    navJobAlerts: 'ఉద్యోగ సమాచారం',
    navEnquiry: 'విచారణ',
    navLegal: 'నిబంధనలు',
    navMenu: 'మెనూ',
    navCloseMenu: 'నావిగేషన్ మెనూను మూసివేయండి',
    navOpenMenu: 'నావిగేషన్ మెనూను తెరవండి',
    privacyPolicy: 'గోప్యతా విధానం',
    locsyTerms: 'లాక్సీ నిబంధనలు',
    lmsTerms: 'LMS నిబంధనలు',
    disclaimer: 'డిస్‌క్లైమర్',
    refundPolicy: 'రీఫండ్ విధానం',
    cookiePolicy: 'కుకీ విధానం',
    deleteAccount: 'ఖాతాను తొలగించండి',
    footerBlurb: 'లాక్సీ సిటిజన్ మరియు లాక్సీ మిత్ర — స్థానిక దుకాణాలు, లిస్టింగ్‌లు, మరియు మెంబర్‌షిప్ ప్లాన్‌లు.',
    contact: 'సంప్రదించండి',
    enquiryForm: 'విచారణ ఫారం',
    locsyCitizen: 'లాక్సీ సిటిజన్',
    copyright: '© {year} లాక్సీ. అన్ని హక్కులు రక్షించబడ్డాయి.',
    brandHome: 'లాక్సీ హోమ్',
    changeLanguage: 'భాష',

    pageTitle: 'విచారణ — లాక్సీ',
    kicker: 'లాక్సీ',
    title: 'విచారణ',
    lead: 'మీకు ఏం కావాలో చెప్పండి — ఒక్కొక్క దశగా. లాగిన్ అవసరం లేదు.',
    callNow: 'ఇప్పుడే సహాయం కావాలా? కాల్ చేయండి',
    whatsapp: 'వాట్సాప్',
    waPrefill: 'నమస్తే, నాకు ఒక విచారణ ఉంది.',

    purposeTitle: 'మీకు ఏం సహాయం కావాలి?',
    purposeSub: 'ఒకటి ఎంచుకోండి — వివరాలు తర్వాత చెప్పవచ్చు.',
    purposeJob: 'ఉద్యోగ నోటిఫికేషన్ విచారణ',
    purposeJobHint: 'వాట్సాప్‌లో ప్రభుత్వ / ప్రైవేట్ ఉద్యోగ అలర్ట్‌లు',
    purposeCourse: 'కోర్సు / శిక్షణ విచారణ',
    purposeCourseHint: 'కంప్యూటర్ కోర్సులు, టైపింగ్, సర్టిఫికేషన్లు',
    purposeService: 'ప్రభుత్వ / ఆన్‌లైన్ సేవ',
    purposeServiceHint: 'ఆధార్, సర్టిఫికేట్లు, దరఖాస్తులు',
    purposeCertificate: 'సర్టిఫికేట్ / హాల్ టికెట్ సహాయం',
    purposeCertificateHint: 'ఫలితాలు, హాల్ టికెట్లు, వెరిఫికేషన్',
    purposeProduct: 'ప్రోడక్ట్ లేదా షాప్ పని',
    purposeProductHint: 'ప్రింట్, జెరాక్స్, ఫారాలు, ఇతర కౌంటర్ పని',
    purposeLocsy: 'లాక్సీ సిటిజన్ యాప్ సహాయం',
    purposeLocsyHint: 'డౌన్‌లోడ్, లాగిన్, కూపన్లు, టౌన్ లిస్టింగ్‌లు',
    purposeMitra: 'మిత్ర / షాప్ యాప్ సహాయం',
    purposeMitraHint: 'బిల్లింగ్, షాప్ QR, మిత్ర లాగిన్ లేదా సెటప్',
    purposeAppTech: 'యాప్ లాగిన్ లేదా సాంకేతిక సమస్య',
    purposeAppTechHint: 'OTP, క్రాష్, అప్‌డేట్ లేదా ఖాతా సమస్యలు',
    purposeOther: 'ఇతర విచారణ',
    purposeOtherHint: 'మీ మాటల్లో చెప్పండి',
    describeBriefly: 'క్లుప్తంగా వివరించండి',
    describePlaceholder: 'ఉదా. రేషన్ కార్డ్ సహాయం కావాలి',

    nameTitle: 'మీ పేరు ఏమిటి?',
    nameSub: 'మా టీమ్ కాల్ చేసినప్పుడు మిమ్మల్ని పేరుతో పిలవడానికి.',
    fullName: 'పూర్తి పేరు',
    namePlaceholder: 'మీ పేరు',

    phoneTitle: 'మీ మొబైల్ నంబర్',
    phoneSub: 'మా టీమ్ మీకు కాల్ చేయడానికి నంబర్ ఇవ్వండి. OTP కూడా పంపడానికి ప్రయత్నిస్తాం.',
    phoneLabel: '10 అంకెల మొబైల్',
    sendingOtp: 'సేవ్ చేసి OTP పంపుతున్నాం…',
    sendOtp: 'సేవ్ చేసి OTP పంపండి',
    callbackConsent:
      'KNLS / లాక్సీ స్టాఫ్ నా విచారణ గురించి ఈ నంబర్‌కు కాల్ లేదా WhatsApp చేయవచ్చని నేను అంగీకరిస్తున్నాను.',
    callbackConsentNote:
      'మీరు ఇప్పటికే కాల్‌బ్యాక్‌కు అంగీకరించారు. OTP విఫలమైనా మీ లీడ్ ఆపరేటర్లకు కనిపిస్తుంది.',
    leadSavedCall: 'మీ వివరాలు సేవ్ అయ్యాయి. మా టీమ్ త్వరలో కాల్ చేస్తుంది.',
    skipOtpContinue: 'OTP రాలేదా? కొనసాగించండి — మేము కాల్ చేస్తాం',
    otpNotDelivered:
      'OTP SMS రాలేదు. Resend OTP నొక్కండి, లేదా వచ్చిన కోడ్ నమోదు చేయండి.',
    otpSubRetry:
      '+91 {phone} కు OTP రాకపోవచ్చు. Resend OTP నొక్కి, 6 అంకెల కోడ్ నమోదు చేయండి.',
    verifyContinue: 'ధృవీకరించి కొనసాగించండి',

    otpTitle: 'OTP నమోదు చేయండి',
    otpSub: '+91 {phone} కు పంపబడింది',
    otpLabel: '6 అంకెల OTP',
    resendIn: '{seconds}సె లో మళ్లీ పంపండి',
    resendOtp: 'OTP మళ్లీ పంపండి',
    otpSentTo: '+91 {phone} కు OTP పంపబడింది',

    detailsTitle: 'కొన్ని ఐచ్ఛిక వివరాలు',
    detailsSub: 'ఏ ఫీల్డ్‌నైనా దాటవేయవచ్చు — సిద్ధంగా ఉంటే సబ్మిట్ నొక్కండి.',
    villageLabel: 'గ్రామం / పట్టణం (ఐచ్ఛికం)',
    villagePlaceholder: 'ఉదా. మర్రిబండం',
    addressLabel: 'చిరునామా (ఐచ్ఛికం)',
    addressPlaceholder: 'ల్యాండ్‌మార్క్ లేదా వీధి',
    callTimeLegend: 'మీకు కాల్ చేయడానికి మంచి సమయం',
    callAnytime: 'ఎప్పుడైనా',
    callMorning: 'ఉదయం (9–12)',
    callAfternoon: 'మధ్యాహ్నం (12–4)',
    callEvening: 'సాయంత్రం (4–8)',
    remarksLabel: 'ఇంకేమైనా ఉన్నాయా? (ఐచ్ఛికం)',
    remarksPlaceholder: 'కోర్సు పేరు, ఉద్యోగ రకం, అవసరమైన పత్రాలు…',
    summaryName: 'పేరు',
    summaryPhone: 'ఫోన్',
    summaryNeed: 'అవసరం',
    submitting: 'సమర్పిస్తున్నాం…',
    submitEnquiry: 'విచారణ సమర్పించండి',

    doneTitle: 'విచారణ అందింది',
    thanksNamed: 'ధన్యవాదాలు {name}! మా టీమ్ {need} గురించి మీకు కాల్ చేస్తుంది.',
    thanksAnon: 'ధన్యవాదాలు! మా టీమ్ {need} గురించి మీకు కాల్ చేస్తుంది.',
    callDirect: 'మీరు నేరుగా కూడా కాల్ చేయవచ్చు:',
    callNumber: '{num} కు కాల్ చేయండి',
    anotherEnquiry: 'మరో విచారణ సమర్పించండి',

    back: '← వెనక్కి',
    continue: 'కొనసాగించండి',
    footnote:
      'మీరు ఫోన్ నంబర్ ఇచ్చిన వెంటనే (అనుమతితో) మీ విచారణ Leads → Enquiries లో సేవ్ అవుతుంది. OTP నంబర్ నిర్ధారణకు మాత్రమే — ఖాతా సృష్టించబడదు.',

    errChoosePurpose: 'మీకు ఏం సహాయం కావాలో ఎంచుకోండి',
    errDescribe: 'మీ విచారణను క్లుప్తంగా వివరించండి',
    errName: 'దయచేసి మీ పూర్తి పేరు నమోదు చేయండి',
    errPhone: 'సరైన 10 అంకెల మొబైల్ నంబర్ ఇవ్వండి',
    errOtp: '6 అంకెల OTP నమోదు చేయండి',
    errConsent: 'స్టాఫ్ మీకు సహాయం చేయడానికి కాల్‌బ్యాక్‌కు అంగీకరించండి',
    errSendOtp: 'OTP పంపడం విఫలమైంది',
    errSendOtpRetry: 'OTP పంపడం విఫలమైంది. మళ్లీ ప్రయత్నించండి.',
    errSubmit: 'విచారణ సమర్పించడం విఫలమైంది',
    errNameRequired: 'పేరు అవసరం',
    errOtpSentMobile: 'మీ మొబైల్‌కు పంపిన 6 అంకెల OTP నమోదు చేయండి',
    errChooseOrDescribe: 'మీకు ఏం సహాయం కావాలో ఎంచుకోండి లేదా వివరించండి',
    errOtpInvalid: 'OTP తప్పు లేదా గడువు ముగిసింది',
    errOtpDigits: 'OTP 6 అంకెలు ఉండాలి',
    errPhoneFormat: 'మొబైల్ నంబర్ ఫార్మాట్ సరైనది కాదు',
    errOtpAttempts: 'చాలా తప్పు OTP ప్రయత్నాలు. కాసేపు ఆగి మళ్లీ ప్రయత్నించండి.',
    errOtpInvalidLater: 'చాలా తప్పు OTP ప్రయత్నాలు. కొత్త OTP తర్వాత అభ్యర్థించండి.',
    errOtpWait: 'మళ్లీ OTP అడగడానికి {seconds}సె వేచి ఉండండి',
    errOtpSms: 'OTP SMS పంపలేకపోయాం. మళ్లీ ప్రయత్నించండి.',
    errConsentApi: 'కొనసాగించే ముందు స్టాఫ్ కాల్‌బ్యాక్‌కు అంగీకరించండి',
  },
  hi: {
    navHome: 'होम',
    navServices: 'सेवाएँ',
    navCourses: 'कोर्स',
    navJobAlerts: 'नौकरी अलर्ट',
    navEnquiry: 'पूछताछ',
    navLegal: 'नियम',
    navMenu: 'मेनू',
    navCloseMenu: 'नेविगेशन मेनू बंद करें',
    navOpenMenu: 'नेविगेशन मेनू खोलें',
    privacyPolicy: 'गोपनीयता नीति',
    locsyTerms: 'लॉक्सी नियम',
    lmsTerms: 'LMS नियम',
    disclaimer: 'अस्वीकरण',
    refundPolicy: 'रिफ़ंड नीति',
    cookiePolicy: 'कुकी नीति',
    deleteAccount: 'खाता हटाएँ',
    footerBlurb: 'लॉक्सी सिटीजन और लॉक्सी मित्रा — स्थानीय दुकानें, लिस्टिंग, और मेंबरशिप प्लान।',
    contact: 'संपर्क',
    enquiryForm: 'पूछताछ फ़ॉर्म',
    locsyCitizen: 'लॉक्सी सिटीजन',
    copyright: '© {year} लॉक्सी. सर्वाधिकार सुरक्षित।',
    brandHome: 'लॉक्सी होम',
    changeLanguage: 'भाषा',

    pageTitle: 'पूछताछ — लॉक्सी',
    kicker: 'लॉक्सी',
    title: 'पूछताछ',
    lead: 'बताइए आपको क्या चाहिए — एक-एक चरण में। लॉगिन की ज़रूरत नहीं।',
    callNow: 'अभी मदद चाहिए? कॉल करें',
    whatsapp: 'व्हाट्सऐप',
    waPrefill: 'नमस्ते, मेरी एक पूछताछ है।',

    purposeTitle: 'आपको किसमें मदद चाहिए?',
    purposeSub: 'एक विकल्प चुनें — विवरण बाद में जोड़ सकते हैं।',
    purposeJob: 'नौकरी नोटिफिकेशन पूछताछ',
    purposeJobHint: 'व्हाट्सऐप पर सरकारी / प्राइवेट नौकरी अलर्ट',
    purposeCourse: 'कोर्स / प्रशिक्षण पूछताछ',
    purposeCourseHint: 'कंप्यूटर कोर्स, टाइपिंग, सर्टिफिकेशन',
    purposeService: 'सरकारी / ऑनलाइन सेवा',
    purposeServiceHint: 'आधार, प्रमाणपत्र, आवेदन',
    purposeCertificate: 'प्रमाणपत्र / हॉल टिकट मदद',
    purposeCertificateHint: 'परिणाम, हॉल टिकट, सत्यापन',
    purposeProduct: 'प्रोडक्ट या दुकान का काम',
    purposeProductHint: 'प्रिंट, ज़ेरॉक्स, फ़ॉर्म, अन्य काउंटर काम',
    purposeLocsy: 'लॉक्सी सिटीजन ऐप मदद',
    purposeLocsyHint: 'डाउनलोड, लॉगिन, कूपन, टाउन लिस्टिंग',
    purposeMitra: 'मित्र / दुकान ऐप मदद',
    purposeMitraHint: 'बिलिंग, दुकान QR, मित्र लॉगिन या सेटअप',
    purposeAppTech: 'ऐप लॉगिन या तकनीकी समस्या',
    purposeAppTechHint: 'OTP, क्रैश, अपडेट या खाता समस्याएँ',
    purposeOther: 'अन्य पूछताछ',
    purposeOtherHint: 'अपने शब्दों में बताएँ',
    describeBriefly: 'संक्षेप में बताएँ',
    describePlaceholder: 'जैसे राशन कार्ड में मदद चाहिए',

    nameTitle: 'आपका नाम क्या है?',
    nameSub: 'ताकि हमारी टीम कॉल पर आपका नाम ले सके।',
    fullName: 'पूरा नाम',
    namePlaceholder: 'आपका नाम',

    phoneTitle: 'आपका मोबाइल नंबर',
    phoneSub: 'हमारी टीम आपको कॉल कर सके, इसके लिए नंबर दें। हम OTP भी भेजने की कोशिश करेंगे।',
    phoneLabel: '10 अंकों का मोबाइल',
    sendingOtp: 'सेव करके OTP भेजा जा रहा है…',
    sendOtp: 'सेव करें और OTP भेजें',
    callbackConsent:
      'मैं सहमत हूँ कि KNLS / लॉक्सी स्टाफ मेरी पूछताछ के लिए इस नंबर पर कॉल या WhatsApp कर सकते हैं।',
    callbackConsentNote:
      'आपने कॉलबैक की अनुमति दे दी है। OTP फेल होने पर भी आपका लीड ऑपरेटरों को दिखेगा।',
    leadSavedCall: 'आपकी जानकारी सेव हो गई। हमारी टीम जल्द कॉल करेगी।',
    skipOtpContinue: 'OTP नहीं आया? आगे बढ़ें — हम कॉल करेंगे',
    otpNotDelivered:
      'OTP SMS नहीं पहुँचा। Resend OTP दबाएँ, या आने पर कोड दर्ज करें।',
    otpSubRetry:
      '+91 {phone} पर OTP नहीं आया होगा। Resend OTP दबाकर 6 अंकों का कोड दर्ज करें।',
    verifyContinue: 'पुष्टि करें और आगे बढ़ें',

    otpTitle: 'OTP दर्ज करें',
    otpSub: '+91 {phone} पर भेजा गया',
    otpLabel: '6 अंकों का OTP',
    resendIn: '{seconds}से में फिर भेजें',
    resendOtp: 'OTP फिर भेजें',
    otpSentTo: '+91 {phone} पर OTP भेजा गया',

    detailsTitle: 'कुछ वैकल्पिक विवरण',
    detailsSub: 'किसी भी फ़ील्ड को छोड़ सकते हैं — तैयार हों तो सबमिट दबाएँ।',
    villageLabel: 'गाँव / शहर (वैकल्पिक)',
    villagePlaceholder: 'जैसे मरीबंडम',
    addressLabel: 'पता (वैकल्पिक)',
    addressPlaceholder: 'लैंडमार्क या गली',
    callTimeLegend: 'आपको कॉल करने का सही समय',
    callAnytime: 'कभी भी',
    callMorning: 'सुबह (9–12)',
    callAfternoon: 'दोपहर (12–4)',
    callEvening: 'शाम (4–8)',
    remarksLabel: 'कुछ और? (वैकल्पिक)',
    remarksPlaceholder: 'कोर्स का नाम, नौकरी का प्रकार, ज़रूरी दस्तावेज़…',
    summaryName: 'नाम',
    summaryPhone: 'फ़ोन',
    summaryNeed: 'ज़रूरत',
    submitting: 'सबमिट हो रहा है…',
    submitEnquiry: 'पूछताछ सबमिट करें',

    doneTitle: 'पूछताछ मिल गई',
    thanksNamed: 'धन्यवाद {name}! हमारी टीम {need} के बारे में आपको कॉल करेगी।',
    thanksAnon: 'धन्यवाद! हमारी टीम {need} के बारे में आपको कॉल करेगी।',
    callDirect: 'आप हमें सीधे भी कॉल कर सकते हैं:',
    callNumber: '{num} पर कॉल करें',
    anotherEnquiry: 'एक और पूछताछ सबमिट करें',

    back: '← वापस',
    continue: 'आगे बढ़ें',
    footnote:
      'फ़ोन नंबर देते ही (सहमति के साथ) आपकी पूछताछ Leads → Enquiries में सेव हो जाती है। OTP केवल नंबर की पुष्टि के लिए है — खाता नहीं बनता।',

    errChoosePurpose: 'कृपया चुनें कि आपको किसमें मदद चाहिए',
    errDescribe: 'कृपया अपनी पूछताछ संक्षेप में बताएँ',
    errName: 'कृपया अपना पूरा नाम दर्ज करें',
    errPhone: 'सही 10 अंकों का मोबाइल नंबर दर्ज करें',
    errOtp: '6 अंकों का OTP दर्ज करें',
    errConsent: 'कृपया कॉलबैक के लिए सहमत हों ताकि स्टाफ आपकी मदद कर सके',
    errSendOtp: 'OTP भेजना असफल रहा',
    errSendOtpRetry: 'OTP भेजना असफल रहा। फिर कोशिश करें।',
    errSubmit: 'पूछताछ सबमिट करना असफल रहा',
    errNameRequired: 'नाम आवश्यक है',
    errOtpSentMobile: 'आपके मोबाइल पर भेजा गया 6 अंकों का OTP दर्ज करें',
    errChooseOrDescribe: 'कृपया चुनें या बताएँ कि आपको किसमें मदद चाहिए',
    errOtpInvalid: 'OTP गलत है या समय समाप्त हो गया',
    errOtpDigits: 'OTP 6 अंकों का होना चाहिए',
    errPhoneFormat: 'मोबाइल नंबर का फ़ॉर्मैट सही नहीं है',
    errOtpAttempts: 'बहुत बार गलत OTP। थोड़ी देर बाद कोशिश करें।',
    errOtpInvalidLater: 'बहुत बार गलत OTP। बाद में नया OTP माँगें।',
    errOtpWait: 'फिर OTP माँगने से पहले {seconds}से प्रतीक्षा करें',
    errOtpSms: 'OTP SMS नहीं भेज सके। फिर कोशिश करें।',
    errConsentApi: 'आगे बढ़ने से पहले स्टाफ कॉलबैक के लिए सहमत हों',
  },
};

const PURPOSE_KEYS = {
  job: { label: 'purposeJob', hint: 'purposeJobHint' },
  course: { label: 'purposeCourse', hint: 'purposeCourseHint' },
  service: { label: 'purposeService', hint: 'purposeServiceHint' },
  certificate: { label: 'purposeCertificate', hint: 'purposeCertificateHint' },
  product: { label: 'purposeProduct', hint: 'purposeProductHint' },
  locsy: { label: 'purposeLocsy', hint: 'purposeLocsyHint' },
  mitra: { label: 'purposeMitra', hint: 'purposeMitraHint' },
  app_tech: { label: 'purposeAppTech', hint: 'purposeAppTechHint' },
  other: { label: 'purposeOther', hint: 'purposeOtherHint' },
};

const CALL_TIME_KEYS = {
  anytime: 'callAnytime',
  morning: 'callMorning',
  afternoon: 'callAfternoon',
  evening: 'callEvening',
};

const API_ERROR_KEYS = {
  'Enter a valid 10-digit mobile number': 'errPhone',
  'Failed to send OTP': 'errSendOtp',
  'Failed to send OTP. Please try again.': 'errSendOtpRetry',
  'Failed to submit enquiry': 'errSubmit',
  'Name is required': 'errNameRequired',
  'Enter the 6-digit OTP sent to your mobile': 'errOtpSentMobile',
  'Enter the 6-digit OTP': 'errOtp',
  'Please choose or describe what you need help with': 'errChooseOrDescribe',
  'Invalid or expired OTP': 'errOtpInvalid',
  'OTP must be 6 digits': 'errOtpDigits',
  'Invalid phone number format': 'errPhoneFormat',
  'Too many failed OTP attempts. Please wait and try again.': 'errOtpAttempts',
  'Too many invalid OTP attempts. Please request a new OTP later.': 'errOtpInvalidLater',
  'Please agree to a callback from our staff before continuing': 'errConsentApi',
  'OTP could not be delivered by SMS. Check SMS provider configuration.': 'errOtpSms',
};

function interpolate(text, vars = {}) {
  return Object.entries(vars).reduce(
    (out, [key, value]) => out.split(`{${key}}`).join(String(value ?? '')),
    text,
  );
}

export function tPublic(language, key, vars = {}) {
  const dict = STRINGS[language] || STRINGS.en;
  const text = dict[key] || STRINGS.en[key] || key;
  return interpolate(text, vars);
}

export function purposeOptions(language) {
  return PURPOSE_PRESETS.map((opt) => ({
    ...opt,
    label: tPublic(language, PURPOSE_KEYS[opt.id].label),
    hint: tPublic(language, PURPOSE_KEYS[opt.id].hint),
  }));
}

export function callTimeOptions(language) {
  return CALL_TIME_PRESETS.map((opt) => ({
    ...opt,
    label: tPublic(language, CALL_TIME_KEYS[opt.id]),
  }));
}

export function translateApiMessage(language, message) {
  const raw = String(message || '').trim();
  if (!raw) return '';
  const waitMatch = raw.match(/Please wait (\d+)s before requesting OTP again/i);
  if (waitMatch) return tPublic(language, 'errOtpWait', { seconds: waitMatch[1] });
  const key = API_ERROR_KEYS[raw];
  if (key) return tPublic(language, key);
  return raw;
}
